
  import { defineComponent } from "vue"
  import { useI18n } from "vue-i18n"

  const Component = defineComponent({
    name: "NotFound",
    setup() {
      const { t } = useI18n()

      return { t }
    },
  })

  export default Component
